"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var paginated_table_hook_1 = require("./paginated-table.hook");
var pagination_component_1 = __importDefault(require("../pagination/pagination.component"));
var paginated_table_styles_1 = require("./paginated-table.styles");
var table_component_1 = __importDefault(require("../table/table.component"));
function PaginatedTable(props) {
    var headers = props.headers, currentPage = props.currentPage, rowsPerPage = props.rowsPerPage, onChange = props.onChange, noOfRows = props.noOfRows, rowsPerPageOptions = props.rowsPerPageOptions;
    var result = paginated_table_hook_1.usePagination(headers, { currentPage: currentPage, rowsPerPage: rowsPerPage }, onChange);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(table_component_1.default, __assign({}, props, result.sorting)),
        react_1.default.createElement(paginated_table_styles_1.PaginationWrapper, null,
            react_1.default.createElement(pagination_component_1.default, __assign({ noOfRows: noOfRows }, result.pagination, { rowsPerPageOptions: rowsPerPageOptions })))));
}
PaginatedTable.displayName = 'PaginatedTable';
exports.default = PaginatedTable;
//# sourceMappingURL=paginated-table.component.js.map